import { Pipe, type PipeTransform, inject } from '@angular/core';
import type { ReferenceListItem, ReferenceListName } from '../reference-lists.interface';
import { ReferenceListsService } from '../reference-lists.service';

@Pipe({
    name: 'referenceList',
    pure: false
})
export class ReferenceListPipe implements PipeTransform {
    private _referenceListsService = inject(ReferenceListsService);

    transform(code: string, listName: ReferenceListName): ReferenceListItem {
        return this._referenceListsService.getReferenceListItemR(listName, code);
    }
}
